"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DELETE_PRODUCT_TREE_NODE = void 0;
const gql_1 = require("../../../../__generated__/gql");
exports.DELETE_PRODUCT_TREE_NODE = (0, gql_1.gql)(`
  mutation DeleteProductTreeNode($productTreeNode: DeleteProductTreeNodeInput!) {
    deleteProductTreeNode(productTreeNode: $productTreeNode) {
      error
      success
    }
  }
`);
